/**
 * Rótulos UI — Agendamento de Docas de Entrada (#MT-B2FA396 Fase 3B).
 */

export const DOCK_TYPE_LABELS = {
	DRY: 'Seca',
	REFRIGERATED: 'Refrigerada',
	CLIMATE_CONTROLLED: 'Climatizada',
	MIXED: 'Mista',
};

export const STATUS_LABELS = {
	SCHEDULED: 'Agendado',
	IN_RECEIVING: 'Em recebimento',
	COMPLETED: 'Concluído',
	CANCELLED: 'Cancelado',
	NO_SHOW: 'Não compareceu',
};

export const EVENT_LABELS = {
	CREATED: 'Criado',
	CANCELLED: 'Cancelado',
	RESCHEDULED: 'Reagendado',
	STATUS_CHANGED: 'Status alterado',
	OCCURRENCE_ADDED: 'Ocorrência adicionada',
	DOCK_CHANGED: 'Doca alterada',
};

export const INCOMPAT_REASON_LABELS = {
	no_working_hours: 'Sem horário de funcionamento neste dia',
	class_incompatible: 'Incompatível com as classes do pedido',
	thermal_dry: 'Pedido refrigerado não cabe em doca seca',
};

export const ACTIVE_STATUSES = new Set(['SCHEDULED', 'IN_RECEIVING']);

export const MSG_FLAG_OFF =
	'Agendamento de Docas de Entrada não está habilitado para esta empresa.';

/**
 * @param {string} status
 * @returns {string}
 */
export function statusLabel(status)
{
	return STATUS_LABELS[status] || status || '—';
}

/**
 * @param {string} dockType
 * @returns {string}
 */
export function dockTypeLabel(dockType)
{
	return DOCK_TYPE_LABELS[dockType] || dockType || '—';
}

/**
 * @param {string} eventType
 * @returns {string}
 */
export function eventLabel(eventType)
{
	return EVENT_LABELS[eventType] || eventType || '—';
}

/**
 * @param {string|null|undefined} reason
 * @returns {string}
 */
export function incompatReasonLabel(reason)
{
	if (!reason) return '';
	return INCOMPAT_REASON_LABELS[reason] || String(reason);
}

/**
 * Formata ISO datetime para data local YYYY-MM-DD.
 * @param {string|Date|null|undefined} iso
 * @returns {string}
 */
export function formatDate(iso)
{
	if (!iso) return '—';
	const d = new Date(iso);
	if (Number.isNaN(d.getTime()))
		return String(iso).slice(0, 10);
	const y = d.getFullYear();
	const m = String(d.getMonth() + 1).padStart(2, '0');
	const day = String(d.getDate()).padStart(2, '0');
	return `${y}-${m}-${day}`;
}

/**
 * Data no padrão operacional SIAL: dd/MM/yyyy.
 * @param {string|Date|null|undefined} iso
 * @returns {string}
 */
export function formatDateBr(iso)
{
	if (!iso) return '—';
	const d = iso instanceof Date ? iso : new Date(iso);
	if (Number.isNaN(d.getTime()))
	{
		const raw = String(iso);
		const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
		return m ? `${m[3]}/${m[2]}/${m[1]}` : raw;
	}
	const y = d.getFullYear();
	const m = String(d.getMonth() + 1).padStart(2, '0');
	const day = String(d.getDate()).padStart(2, '0');
	return `${day}/${m}/${y}`;
}

/**
 * Formata ISO datetime para HH:MM.
 * @param {string|Date|null|undefined} iso
 * @returns {string}
 */
export function formatTime(iso)
{
	if (!iso) return '—';
	const d = new Date(iso);
	if (Number.isNaN(d.getTime()))
	{
		const m = String(iso).match(/T(\d{2}:\d{2})/);
		return m ? m[1] : '—';
	}
	return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

/**
 * @param {string} status
 * @returns {boolean}
 */
export function canMutateStatus(status)
{
	return ACTIVE_STATUSES.has(status);
}
